import { call, put, takeLatest } from 'redux-saga/effects'
import { store as commonAuthStore } from '@maui-mf/common-auth'
import {
  userConfirmationRequest,
  userConfirmationResponse,
  provisioningRequest,
  provisioningResponse,
} from './actions'
import { translate } from '../../utils'
import env from '../../env'
import nautilusApi from '../../nautilusApi'

const fetch = window.fetch
const NAUTILUS_API = env.REACT_APP_API_HOST

const usersApi = {
  provision: (user) => {
    // NOTE this is essentially the same as the original provision API but expects
    // the user, rather than token, and pulls the token from the provider (MF here)
    return nautilusApi.fetch('/provision', {
      method: 'POST',
      as: false,
      body: JSON.stringify({
        user: {
          uid: user.uuid,
          email: user.email,
          first_name: user.firstName,
          last_name: user.lastName
        }
      }),
    }).then(async res => {
      const token = commonAuthStore.getValue()?.token

      if (res.status === 200) {
        const json = await res.json()

        if (json.mandiant_admin) {
          const assign = 'sk_token=' + token + ';'
          const d = new Date()
          d.setTime(d.getTime() + (12 * 60 * 60 * 1000))
          const expires = 'expires=' + d.toUTCString() + ';'
          const domain = 'domain=' + (document.domain.match(/[^.]*\.[^.]*$/) || ['localhost'])[0] + ';'
          const path = 'path=/;'
          const cookie = assign + path + expires + domain
          document.cookie = cookie
        }

        return json
      } else {
        const error = await res.json()
        throw error
      }
    })
  },

  confirm: async (confirmationToken) => {
    const res = await fetch(`${NAUTILUS_API}/confirmation?confirmation_token=${confirmationToken}`)
    let type
    let success
    if (res.status === 200) {
      type = 'verify'
      success = true
    } else {
      const json = await res.json()
      const emailError = json?.errors?.[0]?.detail?.email
      if (emailError && emailError.some(str => str.includes('was already confirmed'))) {
        type = 'confirmed'
      }
      if (emailError && emailError.some(str => str.includes('needs to be confirmed'))) {
        type = 'expired'
      }
      if (!type) {
        type = 'error'
      }
      success = false
    }
    const { heading, message } = translate(`accountMessages.${type}`)
    return { success, heading, message }
  }
}

export function * userConfirmationSaga(action) {
  const { token } = action.payload
  const confirmation = yield call(usersApi.confirm, token)
  yield put(userConfirmationResponse(confirmation))
}

export function * userProvisioningSaga(action) {
  const { user } = action.payload

  try {
    const profile = yield call(usersApi.provision, user)
    yield put(provisioningResponse(profile))
  } catch (error) {
    yield put(provisioningResponse(error))
  }
}

export default function * saga() {
  yield takeLatest(provisioningRequest, userProvisioningSaga)
  yield takeLatest(userConfirmationRequest, userConfirmationSaga)
}
